import React from "react";

const DataNotFound = () => {
  const emoji = window.location.pathname.includes("cart")
  ? "🛒"
  : window.location.pathname.includes("order")
  ? "📦😕"
  : "🔍";
  return (
    <>
      {/* INLINE CSS – SAME FILE */}
      <style>{`
        .data-not-found-wrapper {
          min-height: 70vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          background: #f6f8fb;
        }

        .data-not-found-card {
          background: #ffffff;
          border-radius: 16px;
          padding: 28px 22px;
          max-width: 360px;
          width: 100%;
          text-align: center;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
          animation: fadeInUp 0.6s ease;
        }

        .not-found-emoji {
          font-size: 64px;
          animation: floatEmoji 2s ease-in-out infinite;
          margin-bottom: 10px;
        }

        .data-not-found-title {
          font-size: 22px;
          font-weight: 700;
          margin-bottom: 8px;
          color: #222;
        }

        .data-not-found-text {
          font-size: 14px;
          color: #666;
          line-height: 1.6;
          margin-bottom: 20px;
        }

        .data-not-found-btn {
          background: linear-gradient(135deg, #0d6efd, #4a90ff);
          border: none;
          color: #fff;
          padding: 10px 18px;
          font-size: 14px;
          border-radius: 10px;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .data-not-found-btn:hover {
          transform: translateY(-1px);
          box-shadow: 0 6px 16px rgba(13, 110, 253, 0.4);
          color: #fff;
        }

        @keyframes floatEmoji {
          0% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
          100% { transform: translateY(0); }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Mobile optimization */
        @media (max-width: 480px) {
          .data-not-found-card {
            padding: 24px 18px;
          }

          .not-found-emoji {
            font-size: 56px;
          }

          .data-not-found-title {
            font-size: 20px;
          }
        }
      `}</style>

      {/* UI */}
      <div className="data-not-found-wrapper">
        <div className="data-not-found-card">
          <div className="not-found-emoji">{emoji}</div>

          <h2 className="data-not-found-title">
            Oops! Data Not Found
          </h2>

          <p className="data-not-found-text">
            The information you're looking for doesn’t exist or may have been removed.
            <br />
            Please try again or return to the homepage.
          </p>

          <a href="/" className="data-not-found-btn">
            🏠 Go Home
          </a>
        </div>
      </div>
    </>
  );
};

export default DataNotFound;
